export enum ROOM_TYPE {
  NORMAL = "NORMAL",
  MEETING = "MEETING",
  WEBINAR = "WEBINAR",
  SPEED_NETWORKING = "SPEED_NETWORKING",
  GAME = "GAME",
  TEACHER = "TEACHER"
}
export enum SCENE_FILE {
  BOARD_IMAGE = "BOARD_IMAGE",
  COMMON_IMAGE = "COMMON_IMAGE",
  BACKGROUND_IMAGE = "BACKGROUND_IMAGE",
  LOGO_IMAGE_TYPE = "LOGO_IMAGE_TYPE",
}

export enum SPACE_TYPE {
  OFFICE_TYPE = "OFFICE_TYPE",
  EVENT_TYPE = "EVENT_TYPE",
  EKAM_TYPE = "EKAM_TYPE",
  MINISO_TYPE = "MINISO_TYPE",
  LEARNING_TYPE = "LEARNING_TYPE",
}

export enum USER_TYPE {
  TEACHER = "TEACHER",
  STUDENT = "STUDENT",
  STAFF = "STAFF",
}
